export default class ListDiscountsRequest {
    public constructionSiteId: string | null = null;
    public organizationContractId: string | null = null;
    public status: number | null = null;
}